import { useState } from "react";
import { Input } from "@tellescope/ui";
import { EditableField } from "./EditableField";

export interface EditableTextFieldProps {
  id: string;
  label: string;
  required?: boolean;
  editing: boolean;
  canEdit: boolean;
  value?: string;
  placeholder: string;
  error?: string;
  onStartEditing: () => void;
  onSave: (next: string) => void;
  onCancel: () => void;
}

export const EditableTextField = ({
  id,
  label,
  required,
  editing,
  canEdit,
  value,
  placeholder,
  error,
  onStartEditing,
  onSave,
  onCancel,
}: EditableTextFieldProps) => {
  const [draft, setDraft] = useState(value ?? "");

  const startEditing = () => {
    setDraft(value ?? "");
    onStartEditing();
  };

  // Only fire an update when the value actually changed; otherwise just close the editor.
  const commit = () => {
    if (draft === (value ?? "")) onCancel();
    else onSave(draft);
  };

  return (
    <EditableField
      id={id}
      label={label}
      required={required}
      editing={editing}
      canEdit={canEdit}
      onStartEditing={startEditing}
      displayValue={value}
      placeholder={placeholder}
      error={error}
    >
      <Input
        id={id}
        autoFocus
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commit();
          }
          if (e.key === "Escape") onCancel();
        }}
        onBlur={commit}
      />
    </EditableField>
  );
};
